import KM from '@ott/utility-km';
import noop from 'lodash/noop';
import React, { useContext, FC } from 'react';

type KMProps = {
  children?: React.ReactNode;
  query?: Record<string, string>;
  kmParams?: Record<string, string>;
};

type ContextValues = {
  sendKM: (eventName: string) => void;
};

const Context = React.createContext<ContextValues>({
  sendKM: noop,
});

export const KMProvider: FC<KMProps> = ({ children, kmParams = {}, query = {} }) => {
  const sendKM = (eventName: string) => {
    KM(
      eventName,
      {
        obj: kmParams,
      },
      { query }
    );
  };

  return <Context.Provider value={{ sendKM }}>{children}</Context.Provider>;
};

export const useKM = () => {
  return useContext<ContextValues>(Context);
};
